import { useState } from 'react';
import { useAuth } from '../../lib/auth';
import ui from '../../styles/ui.module.css';
import s from './login.module.css';

/** Tela única de login — a SPA inteira é atrás do login, não tem rota pública (mesmo padrão de
 *  `apps/painel`). Formulário embutido (grant direto no Keycloak, client `storeo-admin`, role
 *  `platform-staff`) — nunca sai da cara do Storeo pro tema padrão do Keycloak. */
export function LoginScreen() {
  const { login, error, status } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return (
    <div className={s.wrap}>
      <div className={s.card}>
        <span className={s.mark} aria-hidden="true">
          S
        </span>
        <h1>Storeo Admin</h1>
        <p>Entre com sua conta de equipe para acessar a visão da plataforma.</p>
        <form
          className={s.form}
          onSubmit={(e) => {
            e.preventDefault();
            login(email, password);
          }}
        >
          <label className={ui.field}>
            E-mail
            <input
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <label className={ui.field}>
            Senha
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          {error ? <p className={ui.error}>{error}</p> : null}
          <button className={s.enter} type="submit" disabled={status === 'checking'}>
            {status === 'checking' ? 'Entrando…' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
